import { Link } from 'react-router-dom';

const LOGO_URL = "/coyp-logo.png";

const Footer = ({ theme = 'dark' }) => {
  const isLight = theme === 'light';
  return (
    <>
      <footer
        className={`border-t ${isLight ? 'border-gray-200 bg-[#F9FAFB]' : 'border-[#222] bg-black'}`}
        data-testid="main-footer"
      >
        <div className="max-w-4xl mx-auto px-4 py-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="text-center sm:text-left">
              <img 
                src={LOGO_URL} 
                alt="Check On Yo Peoples TV" 
                className="h-14 object-contain"
              />
            </div>

            <div className="flex gap-6 flex-wrap justify-center">
              <Link to="/" data-testid="footer-nav-feed" className={`text-sm hover:text-yellow-600 ${isLight ? 'text-gray-600' : 'text-gray-500 hover:text-yellow-500'}`}>Feed</Link>
              <Link to="/worldstar" data-testid="footer-nav-worldstar" className={`text-sm hover:text-yellow-600 ${isLight ? 'text-gray-600' : 'text-gray-500 hover:text-yellow-500'}`}>Worldstar</Link>
              <Link to="/check-your-claims" data-testid="footer-nav-claims" className={`text-sm hover:text-yellow-600 ${isLight ? 'text-gray-600' : 'text-gray-500 hover:text-yellow-500'}`}>Claims</Link>
              <Link to="/merch" data-testid="footer-nav-merch" className={`text-sm hover:text-yellow-600 ${isLight ? 'text-gray-600' : 'text-gray-500 hover:text-yellow-500'}`}>Merch</Link>
            </div>
          </div>

          <div className={`border-t mt-6 pt-6 flex flex-col items-center gap-3 ${isLight ? 'border-gray-200' : 'border-[#222]'}`}>
            <div className="flex gap-5 flex-wrap justify-center">
              <Link to="/about" data-testid="footer-about-link" className={`text-xs hover:text-yellow-600 ${isLight ? 'text-gray-500' : 'text-gray-600 hover:text-yellow-500'}`}>About</Link>
              <Link to="/contact" data-testid="footer-contact-link" className={`text-xs hover:text-yellow-600 ${isLight ? 'text-gray-500' : 'text-gray-600 hover:text-yellow-500'}`}>Contact</Link>
              <Link to="/privacy-policy" data-testid="footer-privacy-link" className={`text-xs hover:text-yellow-600 ${isLight ? 'text-gray-500' : 'text-gray-600 hover:text-yellow-500'}`}>Privacy Policy</Link>
              <Link to="/editorial-policy" data-testid="footer-editorial-policy-link" className={`text-xs hover:text-yellow-600 ${isLight ? 'text-gray-500' : 'text-gray-600 hover:text-yellow-500'}`}>Editorial Policy</Link>
              <Link to="/terms" data-testid="footer-terms-link" className={`text-xs hover:text-yellow-600 ${isLight ? 'text-gray-500' : 'text-gray-600 hover:text-yellow-500'}`}>Terms</Link>
            </div>
            <p className={`text-xs ${isLight ? 'text-gray-500' : 'text-gray-600'}`}>
              &copy; {new Date().getFullYear()} Check On Yo Peoples TV
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
